export default function globalSketchId(sketchId, id) {
  return sketchId + "/" + id;
}